import Test from '../test';

const questionTypeClassDict = {};

class Question {
  // answerSubmitted: <Boolean>

  static get type() {
    const name = this.toString().match(/^function\s*([^\s(]+)/)[1];
    return name.replace(/(.)(?=[A-Z])/g, '$&_').toUpperCase();

    // this.name returns undefine in IE11 and babel does not polyfill it correctly
    // return this.name.replace(/(.)(?=[A-Z])/g, '$&_').toUpperCase();
  }

  static classForType = type => questionTypeClassDict[ type ];

  static register() {
    questionTypeClassDict[ this.type ] = this;
  }

  /**
   * @typedef {number} Operand - Integer in range [1,12]
   *
   * @constructor
   * @param {Array.<Operand>} [config] - length 2
   */
  constructor({ multiplicand, multiplier } = {}) {
    this.config = {};

    if ( typeof multiplicand === 'undefined' ) {
      multiplicand = Math.ceil(12 * Math.random())
    }
    if ( typeof multiplier === 'undefined' ) {
      multiplier = Math.ceil(12 * Math.random())
    }
    this.config.multiplicand = multiplicand;
    this.config.multiplier = multiplier;
  }

  get type() {
    return this.constructor.type;
  }
  get multiplicand() {
    return this.config.multiplicand;
  }
  get multiplier() {
    return this.config.multiplier;
  }
  get product() {
    return this.multiplicand * this.multiplier;
  }
  set answer( val ) {
    this._answer = val;
    Test.eventEmitter.emit('TEST_ANSWER_CHANGED');
  }
  get answer() {
    return typeof this._answer === 'undefined' ? null : this._answer;
  }
  set isCompleted( val ) {
    this._completed = val;

    if ( this._completed ) {
      Test.eventEmitter.emit('TEST_QUESTION_COMPLETED', this);
      this.tool.onQuestionComplete(this);
    }
  }
  get isCompleted() {
    return this._completed === true;
  }
  get title() {
    return '';
  }
}

export default Question;
